import {stringify} from 'qs';
import {v4 as uuidV4} from 'uuid';
import {SearchAutoCompleteVo} from '../../common/shared/api/nicolas/vo/SearchAutoCompleteVo.interface';
import {SearchAutoComplete} from '../generated/types';

export function createSearchAutoComplete({
  keyword,
  list,
}: SearchAutoCompleteVo): SearchAutoComplete {
  return {
    id: uuidV4(),
    keyword,
    list:
      list?.map(text => ({
        text,
        url: `/search/result?${stringify({keyword: text})}`,
      })) || [],
  };
}
